export { getStudyIsData } from './getStudyIsData'
